type ReleaseInfo = {
	release: string;
	build: string;
	commit: string;
}

const releaseInfo: ReleaseInfo = {
	release: '__RELEASE__',
	build: '127',
	commit: 'e7c4fe8'
};

export { releaseInfo };
